export default __webpack_public_path__ + "static/media/data4.7b6f6a1c.svg";